import { keyStateChange } from '../redux/ui/actions';
import { store } from '../redux/store';

export class KeyStateTracker {
  private static _instance: KeyStateTracker;

  private keysToTrack: any;

  public static getInstance(): KeyStateTracker {
    if (!KeyStateTracker._instance) {
      KeyStateTracker._instance = new KeyStateTracker();
    }
    return KeyStateTracker._instance;
  }

  public attachEventListeners(keyCodesToTrack: number[]): void {
    this.keysToTrack = {};
    keyCodesToTrack.forEach((code) => (this.keysToTrack[code] = true));

    window.document.addEventListener('keydown', (e: KeyboardEvent) => {
      this.onkeydown(e);
    });
    window.document.addEventListener('keyup', (e: KeyboardEvent) => {
      this.onkeyup(e);
    });
  }

  private onkeydown(e: KeyboardEvent): void {
    if (this.keysToTrack[e.keyCode]) {
      store.dispatch(keyStateChange(e.keyCode, true));
    }
  }

  private onkeyup(e: KeyboardEvent): void {
    if (this.keysToTrack[e.keyCode]) {
      store.dispatch(keyStateChange(e.keyCode, false));
    }
  }
}
